import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import SpecialConsiderationReportDetails from '../../modules/admin/components/SpecialConsiderationReport/SpecialConsiderationReportDetails';

const SpecialConsiderationReport = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>SpecialConsiderationReport.SpecialConsiderationReport')} />

      <SpecialConsiderationReportDetails />
    </>
  );
};

export default SpecialConsiderationReport;
